import { paths } from '@/app/routes/paths';
import { useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useVerifyEmailFlow, VerifyEmailResult } from '@/features/Auth';

const VerifyEmailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [verificationToken] = useState(() => new URLSearchParams(location.search).get('token')?.trim() ?? '');

  const onNavigateToLogin = useCallback((): void => {
    navigate(paths.login);
  }, [navigate]);

  const onNavigateToMain = useCallback((): void => {
    navigate(paths.main);
  }, [navigate]);

  const onRemoveVerificationToken = useCallback((): void => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.delete('token');

    navigate(
      {
        hash: location.hash,
        pathname: paths.verifyEmail,
        search: searchParams.toString()
      },
      {
        replace: true
      }
    );
  }, [location.hash, location.search, navigate]);

  const verifyEmailResultProps = useVerifyEmailFlow({
    onNavigateToLogin,
    onNavigateToMain,
    onRemoveVerificationToken,
    pathname: location.pathname,
    verificationToken
  });

  return <VerifyEmailResult {...verifyEmailResultProps} />;
};

export default VerifyEmailPage;